<!--
/**
 * author: vformAdmin
 * email: vdpadmin@163.com
 * website: https://www.vform666.com
 * date: 2021.08.18
 * remark: 如果要分发VForm源码，需在本文件顶部保留此文件头信息！！
 */
-->

<template>
  <container-wrapper
    :designer="designer"
    :widget="widget"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
  >
    <div
      :key="widget.id"
      class="tab-container"
      :class="{ selected: selected }"
      @click.stop="selectWidget(widget)"
    >
      <el-tabs
        :type="widget.displayType"
        v-model="activeTab"
        @tab-click="onTabClick"
      >
        <el-tab-pane
          v-for="(tab, index) in widget.tabs"
          :key="index"
          :label="tab.options.label"
          :name="tab.options.name"
          @click.native.stop="selectWidget(widget)"
        >
          <draggable
            :list="tab.widgetList"
            v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 200 }"
            handle=".drag-handler"
            @add="(evt) => onContainerDragAdd(evt, tab.widgetList)"
            @update="onContainerDragUpdate"
            :move="checkContainerMove"
          >
            <transition-group name="fade" tag="div" class="form-widget-list">
              <template v-for="(subWidget, swIdx) in tab.widgetList">
                <template v-if="'container' === subWidget.category">
                  <component
                    :is="subWidget.type + '-widget'"
                    :widget="subWidget"
                    :designer="designer"
                    :key="subWidget.id"
                    :parent-list="tab.widgetList"
                    :index-of-parent-list="swIdx"
                    :parent-widget="widget"
                  ></component>
                </template>
                <template v-else>
                  <component
                    :is="subWidget.type + '-widget'"
                    :field="subWidget"
                    :designer="designer"
                    :key="subWidget.id"
                    :parent-list="tab.widgetList"
                    :index-of-parent-list="swIdx"
                    :parent-widget="widget"
                    :design-state="true"
                  ></component>
                </template>
              </template>
            </transition-group>
          </draggable>
        </el-tab-pane>
      </el-tabs>
    </div>
  </container-wrapper>
</template>

<script>
import Draggable from "vuedraggable";
import i18n from "@/utils/i18n";
import containerMixin from "@/components/form-designer/form-widget/container-widget/containerMixin";
import ContainerWrapper from "@/components/form-designer/form-widget/container-widget/container-wrapper";
import FieldComponents from "@/components/form-designer/form-widget/field-widget/index";
import refMixinDesign from "@/components/form-designer/refMixinDesign";

export default {
  name: "tab-widget",
  componentName: "ContainerWidget",
  mixins: [i18n, containerMixin, refMixinDesign],
  inject: ["refList"],
  components: {
    ContainerWrapper,
    Draggable,

    ...FieldComponents,
  },
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
  },
  data() {
    return {
      activeTab: "tab1",
      //
    };
  },
  computed: {
    selected() {
      return this.widget.id === this.designer.selectedId;
    },

    customClass() {
      return this.widget.options.customClass || "";
    },
  },
  watch: {
    //
  },
  created() {
    this.initRefList();
  },
  mounted() {
    //
  },
  methods: {
    onTabClick(evt) {
      let paneName = evt.name;
      this.widget.tabs.forEach((tp) => {
        tp.options.active = tp.options.name === paneName;
      });
    },
  },
};
</script>
<style>
.el-tabs--border-card > .el-tabs__header .el-tabs__item:first-child {
  margin-left: 0px;
}
</style>
<style lang="scss" scoped>
.tab-container {
  margin: 0px;
  .form-widget-list {
    min-height: 28px;
  }
}

::v-deep .el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.tab-container.selected {
  outline: 2px solid $--color-primary !important;
}
::v-deep .el-tabs__item {
  height: 29px;
  line-height: 29px;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  background-color: #fff;
  border-bottom: 1px solid var(--main-color);
  margin: 0;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: var(--main-color);
  border-right-color: var(--main-color);
  border-left-color: var(--main-color);
  border-top: 1px solid var(--main-color);
  margin-top: 1px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  font-weight: bold;
  margin-left: 0px;
}
::v-deep
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item
  + .el-tabs__item,
.el-tabs--border-card > .el-tabs__header .el-tabs__item:first-child {
  margin-left: 0px;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  padding-left: 5px;
  box-sizing: border-box;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #3b3b3b;
}
::v-deep .el-tabs .el-tabs__content {
  // height: 596px;
  overflow-y: auto;
  padding-right: 10px;
}
</style>
